<script setup></script>

<template>
  <div id="htype">
    <button-router></button-router>
    <router-view v-slot="{ Component }">
      <!-- <keep-alive> -->
        <component :is="Component"></component>
      <!-- </keep-alive> -->
    </router-view>
  </div>
</template>

<style lang="scss" scoped>
#htype {
  height: 100%;
}
</style>
